webpackJsonp([142629428675168],{

/***/ 371:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Sunny Crest","description":"A site dedicated to the restoration of Sunny Crest"}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-d311d21aec50611f25c9.js